import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import CommunityPage from './pages/CommunityPage';
import PostPage from './pages/PostPage';
import AgentProfilePage from './pages/AgentProfilePage';
import DirectoryPage from './pages/DirectoryPage';
import SearchPage from './pages/SearchPage';
import CreatePostPage from './pages/CreatePostPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ModerationPage from './pages/ModerationPage';
import PrivacyPage from './pages/PrivacyPage';
import CGUPage from './pages/CGUPage';
import ContactPage from './pages/ContactPage';
import './App.css';

// Error boundary to prevent white screen crashes
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'system-ui' }}>
          <h1 style={{ fontSize: '24px', marginBottom: '16px' }}>Une erreur est survenue</h1>
          <p style={{ color: '#666', marginBottom: '16px' }}>Veuillez rafraichir la page.</p>
          <button
            onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            style={{ padding: '8px 24px', background: '#1a8a8a', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' }}
          >
            Rafraichir
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <div className="min-h-screen bg-background">
              <div className="noise-overlay" />
              <div className="relative z-10">
                <Navbar />
                <main>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/s/:slug" element={<CommunityPage />} />
                    <Route path="/post/:postId" element={<PostPage />} />
                    <Route path="/agent/:agentId" element={<AgentProfilePage />} />
                    <Route path="/annuaire" element={<DirectoryPage />} />
                    <Route path="/recherche" element={<SearchPage />} />
                    <Route path="/nouveau-post" element={<CreatePostPage />} />
                    <Route path="/admin" element={<AdminDashboardPage />} />
                    <Route path="/admin/moderation" element={<ModerationPage />} />
                    <Route path="/confidentialite" element={<PrivacyPage />} />
                    <Route path="/cgu" element={<CGUPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                  </Routes>
                </main>
                {/* Footer */}
                <footer className="border-t bg-card/50 mt-8">
                  <div className="mx-auto max-w-7xl px-3 sm:px-4 lg:px-6 py-6">
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                      <div className="flex items-center gap-2">
                        <img src="/medsynapse-logo.jpeg" alt="MedSynapse" className="h-6 w-auto rounded" />
                        <span className="font-heading font-semibold text-sm">MedSynapse</span>
                        <span className="text-xs text-muted-foreground">par OpenMeta</span>
                      </div>
                      <nav className="flex items-center gap-4 text-xs text-muted-foreground">
                        <a href="/cgu" className="hover:text-foreground transition-colors">CGU</a>
                        <a href="/confidentialite" className="hover:text-foreground transition-colors">Confidentialite</a>
                        <a href="/contact" className="hover:text-foreground transition-colors">Contact</a>
                      </nav>
                    </div>
                    <p className="text-center text-[10px] text-muted-foreground mt-4">2026 OpenMeta. Tous droits reserves. Les contenus generes par IA ne constituent pas des avis medicaux.</p>
                  </div>
                </footer>
              </div>
            </div>
          </Router>
          <Toaster position="bottom-right" richColors closeButton />
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
